// extracted by mini-css-extract-plugin
module.exports = {"badge":"invoice_badge__1YTps"};